module.exports = {
          srcSet: __webpack_public_path__ + "public/a4305c1e6432d21f2b6f5863043ee153-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/a4305c1e6432d21f2b6f5863043ee153-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/a4305c1e6432d21f2b6f5863043ee153-80.png",
          toString:function(){return __webpack_public_path__ + "public/a4305c1e6432d21f2b6f5863043ee153-80.png"},
          
          width: 80,
          height: 80
        }